import { useCallback, useContext, useEffect, useState } from 'react';

import { Tabs } from '@hdi-seguros/web-components.tabs';
import { FormCoverages } from './components/Form';
import { StepThreeFormContext } from '../../../../../StepThree/contexts';
import { ColSize, RowSize } from '../../../../../../../../../../../shared/components';

export const PropertyDataSection = () => {
  const { personalEffectsQuotationComponents } = useContext( StepThreeFormContext );

  const [activeTab, setActiveTab] = useState<any>(personalEffectsQuotationComponents[0]?.nroComponente);
  const [tabs, setTabs] = useState<Array<any>>([]);

  const createTabs = useCallback(() => {
    const newTabs = personalEffectsQuotationComponents.map((personalEffectsComponent, index: number) => ({
      children: (
        <FormCoverages personalEffectsComponent={personalEffectsComponent} />
      ),
      closable: false,
      forceRender: true,
      key: personalEffectsComponent.nroComponente,
      label: `Efectos Personales ${personalEffectsComponent.nroComponente}`,
    }));

    setTabs(newTabs);
  }, [personalEffectsQuotationComponents, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <RowSize className='mt-1'>
      <ColSize size={100}>
        <Tabs
          activeKey={activeTab}
          handlePressTab={handlePressTab}
          items={tabs}
        />
      </ColSize>
    </RowSize>
  );
};
